<script setup>
import NewsPageBodyPostHeader from "@/components/NewsPage/NewsPageBody/NewsPageBodyPost/NewsPageBodyPostHeader.vue";
import NewsPageBodyPostBody from "@/components/NewsPage/NewsPageBody/NewsPageBodyPost/NewsPageBodyPostBody.vue";
import ChevronUp from "@/components/Icons/ChevronUp.vue";
import {computed, onMounted, ref, defineEmits, defineProps} from "vue";
import NewsPageBodyPostFooter from "@/components/NewsPage/NewsPageBody/NewsPageBodyPost/NewsPageBodyPostFooter.vue";
import {useNewsFeedStore} from "@/store/NewsFeed/newsFeed";
import NewsPageObjectList from "@/components/NewsPage/NewsPageBody/NewsPageBodyPost/NewsPageObjectList.vue";
import {t} from "@/controllerLK/GlobusLocalization";

const props = defineProps({
  isShowFullNews: {
    type: Boolean,
    default: false
  }
});
const emit = defineEmits(["toggle-show-full-news"]);

const newsFeedStore = useNewsFeedStore();

onMounted(() => {
  // Если в новости отсутсвуют объекты, то по умолчанию открываетася вкладка "Параметры новости"
  if (nameListPersons.value.length === 0 &&  nameListOrganisations.value.length === 0) {
    activeTab.value = tabs[1];
  }
});

// Список табов
const tabs = [
  {
    id: "objects",
    name: t("news_page_full_view.tab.objects")
  },
  {
    id: "settings",
    name: t("news_page_full_view.tab.settings")
  }
];

// Активный таб
const activeTab = ref(tabs[0]);

// Объекты
// Список объектов персон.
const nameListPersons = computed(() => {
  let result = [];
  if (newsFeedStore.currentNews && newsFeedStore.currentNews.ner_result) {
    if (newsFeedStore.currentNews.ner_result.persons) {
      result = result.concat(newsFeedStore.currentNews.ner_result.persons);
    }
  }
  return result;
});

// Список объектов организаций
const nameListOrganisations = computed(() => {
  let result = [];
  if (newsFeedStore.currentNews && newsFeedStore.currentNews.ner_result) {
    if (newsFeedStore.currentNews.ner_result.organisations) {
      result = result.concat(newsFeedStore.currentNews.ner_result.organisations);
    }
  }
  return result;
});
</script>

<template>
  <div class="news-view">
    <!-- ===  Возврат к ленте   -->
    <div class="news-view__control">
      <ButtonAccentSecondary
        class="news-view__control-button"
        @click="emit('toggle-show-full-news')"
      >
        <ChevronUp class="news-view__control-icon" />
        {{ t('news_page_full_view.buttons.to_feed') }}
      </ButtonAccentSecondary>
    </div>
    <!--   Возврат к ленте ===   -->

    <!-- ===   Основное содержимое новости.   -->
    <div class="news-view__content-wrapper scroll">
      <div class="news-view__content">
        <NewsPageBodyPostHeader :is-show-full-news="props.isShowFullNews" />
        <NewsPageBodyPostBody :is-show-full-news="props.isShowFullNews" />
      </div>
    </div>
    <!--   Основное содержимое новости. ===   -->
    <!-- ====   Мета информация по новости. (Объекты и параметры)   -->
    <div class="news-view__meta">
      <TabBar
        v-model="activeTab"
        :tabs="tabs"
        :full-width="true"
      />
      <div class="news-view__meta-view-wrapper scroll">
        <div class="news-view__meta-view">
          <NewsPageBodyPostFooter
            v-if="activeTab.id === 'settings'"
            :is-show-full-news="props.isShowFullNews"
          />
          <template v-else>
            <template v-if="nameListPersons.length > 0 || nameListOrganisations.length > 0">
              <NewsPageObjectList
                v-if="nameListPersons.length > 0"
                :title="t('news_page_full_view.title.persons')"
                :is-show-full-news="props.isShowFullNews"
                :list="nameListPersons"
              />
              <NewsPageObjectList
                v-if="nameListOrganisations.length > 0"
                :title="t('news_page_full_view.title.organisations')"
                :is-show-full-news="props.isShowFullNews"
                :list="nameListOrganisations"
              />
            </template>
            <template v-else>
              <div class="news-view__meta-view--empty">
                {{ t('news_page_body_post.label.not_defined_set') }}
              </div>
            </template>
          </template>
        </div>
      </div>
    </div>
    <!--   Мета информация по новости. (Объекты и параметры) ===   -->
  </div>
</template>

<style scoped lang="scss">

.news-view {
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  display: grid;
  width: 100%;
  height: 100vh;
  margin-bottom: 20px;
  padding: 30px;
  background-color: var(--background-bg-main);
  grid-gap: 20px;
  grid-template-columns: 101px minmax(0, 1fr) 448px;

  &__meta {
    display: flex;
    flex-direction: column;
    min-height: 100%;
    gap: 12px;

    &-view {
      display: flex;
      flex: 1;
      flex-direction: column;
      min-height: 100%;
      padding: 16px;
      border-radius: 8px;
      background-color: var(--background-bg-white);

      &--empty {
        font-size: 14px;
        font-weight: 400;
        line-height: 18px;
        padding: 10px;
        border-radius: 8px;
        background-color: var(--background-01);
        color: var(--purple-purple50);
      }

      &-wrapper {
        overflow: auto;
        min-height: calc(100vh - 110px);
        max-height: calc(100vh - 110px);
        padding-right: 5px;
      }

      gap: 8px;
    }
  }

  &__control {
    &-icon {
      transform: rotate(-90deg);
    }
  }

  &__content-wrapper {
    overflow: auto;
    max-height: calc(100vh - 60px);
    padding-right: 5px;
  }

  &__content {
    display: flex;
    flex-direction: column;
    min-height: 100%;
    padding: 0 24px 24px 24px;
    border-radius: 8px;
    background-color: var(--background-bg-white);
  }
}

</style>